import { Component, OnInit, Inject } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../../../api.service';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-digital-placements-add',
  templateUrl: './college-placements-add.component.html',
  styleUrls: ['./college-placements-add.component.scss']
})
export class CollegePlacementsComponent implements OnInit {

  public specializations = [];
  public streams = [];
  public courses = [];
  public colleges = [];
  public collegeplacements = [];
  collegeplacementsForm: FormGroup;
  public message:any = null;
  public class:any = null;
  submitted = false;

  constructor(private router: Router, private api: ApiService, private formBuilder: FormBuilder, private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public settings = {
    actions: {
      position: 'right',
      add: false
    },
    edit: {
      confirmSave: true
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      stream: {
        title: 'Streams'
      },
      course: {
        title: 'Courses'
      },
      specialization: {
        title: 'Specialization'
      },
      packagetype: {
        title: 'Package Type'
      },
      packagevalue: {
        title: 'Package Value'
      },
      studentsplaced: {
        title: 'Students Placed'
      },
      collegeid: {
        title: 'Collegeid',
        editable:false,
      },
    },
  };

  public config1: DropzoneConfigInterface = {
    clickable: true,
    maxFiles: 1,
    autoReset: null,
    errorReset: null,
    cancelReset: null
  };

  public onUploadInit(args: any): void { }

  public onUploadError(args: any): void { }

  public onUploadSuccess(args: any): void { }

  ngOnInit() {
    this.collegeplacementsForm = this.formBuilder.group({
      specialization: ['', Validators.required],
      stream: ['', Validators.required],
      course: ['', Validators.required],
      packagetype: ['', Validators.required],
      packagevalue: ['', Validators.required],
      studentsplaced: ['', Validators.required],
      collegeid: ['', Validators.required],
      seohidden: ['']
    });

    this.http.get<any>(this.api_endpoint+'/streams').subscribe(
        data => {
          this.streams = data.data;
          // console.log(this.specializations);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    
    this.http.get<any>(this.api_endpoint+'/colleges').subscribe(
        data => {
          this.colleges = data.data;
          // console.log(this.specializations);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });

    this.http.get<any>(this.api_endpoint+'/collegeplacements').subscribe(
        data => {
          this.collegeplacements = data.data;
          // console.log(this.collegecourses);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }
  getcourses(value){

    this.http.get<any>(this.api_endpoint+'/coursess/' + value).subscribe(
        data => {
          this.courses = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  getspecialization(value){

    this.http.get<any>(this.api_endpoint+'/specializationc/' + value).subscribe(
        data => {
          // console.log(this.specializations);
          this.specializations = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.collegeplacementsForm.controls; }

  onFormSubmit() {
    this.submitted = true;

    if (this.collegeplacementsForm.invalid) {
      return;
    }
    // console.log(this.collegeplacementsForm.value);
    this.http.post<any>(this.api_endpoint+'/collegeplacements', this.collegeplacementsForm.value).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        }
        window.location.reload();
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  updateRecord(event) {
    // console.log(event.newData);
    var data = {
                "stream" : event.newData.stream,
                "course" : event.newData.course,
                "specialization" : event.newData.specialization,
                "packagetype" : event.newData.packagetype,
                "packagevalue" : event.newData.packagevalue,
                "studentsplaced" : event.newData.studentsplaced,
                "_id" : event.newData._id,
                "seohidden": event.newData.seohidden
                };
        console.log(data);     
        this.http.put<any>(this.api_endpoint+'/collegeplacements/', data).subscribe(
        res => {
          // console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          }
          event.confirm.resolve(event.newData);
          this.ngOnInit();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  

}
